<template>
  <div class="content_main o_s" style="padding: 5px; box-sizing: border-box">
    <div class="chart_box">
      <div class="serch_box">
        <a-select class="a_select_self margin_self" allowClear size="small" placeholder="年份">
          <a-select-option :value="item.value" v-for="(item, index) in years" :key="index">
            {{ item.label }}
          </a-select-option>
        </a-select>
        <a-select class="a_select_self margin_self" allowClear size="small" placeholder="公司">
          <a-select-option value="jack"> Jack </a-select-option>
        </a-select>
      </div>
      <div class="chart" id="chart1"></div>
    </div>
    <div class="chart_main">
      <div class="main_l">
        <div class="main_box">
          <div class="chart_center" id="chart2"></div>
        </div>
        <div class="main_box" >
          <div class="chart_center" id="chart3"></div>
        </div>
      </div>
      <div class="main_r">
        <div class="chart_center" id="chart4"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      years: [],
      xAxis: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'],
    }
  },
  mounted() {
    var first_year = 2009
    var last_year = new Date().getFullYear()

    for (var i = first_year; i <= last_year; i++) {
      this.years.push({
        value: i,
        label: i + '年',
      })
    }
    this.set_chart1()
    this.set_chart2()
    this.set_chart3()
    this.set_chart4()
  },
  methods: {
    set_chart1() {
      var dom = document.getElementById('chart1')
      var myChartNowMonth = this.$echarts.init(dom)
      var option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
        },
        title: {
          text: '2021年各月份采购金额统计    单位:元',
        },
        legend: {},
        grid: {
          left: '1%',
          right: '1%',
          bottom: '3%',
          top: '70',
          containLabel: true,
        },
        toolbox: {
          show: true,
          left: 0,
          top: 25,
          feature: {
            mark: { show: true },
            dataView: { show: true, readOnly: false },
            magicType: { show: true, type: ['line', 'bar'] },
            restore: { show: true },
            saveAsImage: { show: true },
          },
        },
        xAxis: [
          {
            type: 'category',
            data: this.xAxis,
          },
        ],
        yAxis: [
          {
            type: 'value',
          },
        ],
        series: [
          {
            name: '固定资产',
            type: 'bar',
            barWidth: 24,
            stack: 'Search Engine',
            emphasis: {
              focus: 'series',
            },
            data: [620, 732, 701, 734, 1090, 1130, 1120, 765, 734, 345, 564, 367],
          },
          {
            name: '流动资产',
            type: 'bar',
            stack: 'Search Engine',
            emphasis: {
              focus: 'series',
            },
            data: [120, 132, 101, 134, 290, 230, 220, 345, 111, 231, 563, 643],
          },
        ],
      }
      option && myChartNowMonth.setOption(option)
    },
    set_chart2() {
      var dom = document.getElementById('chart2')
      var myChartNowMonth = this.$echarts.init(dom)
      var option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
        },
        title: {
          text: '不同年份采购金额统计    单位:元',
        },
        legend: {},
        grid: {
          left: '1%',
          right: '1%',
          bottom: '3%',
          top: '70',
          containLabel: true,
        },
        toolbox: {
          show: true,
          left: 0,
          top: 25,
          feature: {
            mark: { show: true },
            dataView: { show: true, readOnly: false },
            magicType: { show: true, type: ['line', 'bar'] },
            restore: { show: true },
            saveAsImage: { show: true },
          },
        },
        xAxis: [
          {
            type: 'category',
            data: this.xAxis,
          },
        ],
        yAxis: [
          {
            type: 'value',
          },
        ],
        series: [
          {
            name: '固定资产',
            type: 'bar',
            barWidth: 20,
            stack: 'Search Engine',
            emphasis: {
              focus: 'series',
            },
            data: [620, 732, 701, 734, 1090, 1130, 1120, 765, 734, 345, 564, 367],
          },
          {
            name: '流动资产',
            type: 'bar',
            stack: 'Search Engine',
            emphasis: {
              focus: 'series',
            },
            data: [120, 132, 101, 134, 290, 230, 220, 345, 111, 231, 563, 643],
          },
        ],
      }
      option && myChartNowMonth.setOption(option)
    },
    set_chart3() {
      var dom = document.getElementById('chart3')
      var myChartNowMonth = this.$echarts.init(dom)
      var option = {
        title: {
          text: '各公司采购金额比例    单位:元',
        },
        tooltip: {
          trigger: 'item',
        },
        legend: {
          top: '10%',
          left: 'left',
          orient: 'vertical',
        },
        series: [
          {
            name: 'Access From',
            type: 'pie',
            radius: ['40%', '60%'],
            itemStyle: {
              normal: {
                label: {
                  show: true,
                  formatter: '{d}%',
                },
                labelLine: {
                  show: true,
                },
              },
            },
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: 'center',
            },
            emphasis: {
              label: {
                show: true,
                fontSize: '20',
                fontWeight: 'bold',
              },
            },
            labelLine: {
              show: false,
            },
            data: [
              { value: 1048, name: 'Search Engine' },
              { value: 735, name: 'Direct' },
              { value: 580, name: 'Email' },
              { value: 484, name: 'Union Ads' },
              { value: 300, name: 'Video Ads' },
            ],
          },
        ],
      }
      option && myChartNowMonth.setOption(option)
    },
    set_chart4() {
      var dom = document.getElementById('chart4')
      var myChartNowMonth = this.$echarts.init(dom)
      var option = {
        title: {
          text: '各公司采购金额总览',
        },
        tooltip: {
          trigger: 'axis',
          left: 'left',
          axisPointer: {
            type: 'shadow',
          },
        },
        legend: {
          left: 0,
          top: 30,
        },
        grid: {
          left: '1%',
          right: '1%',
          bottom: '3%',
          containLabel: true,
        },
        xAxis: {
          type: 'value',
          boundaryGap: [0, 0.01],
        },
        yAxis: {
          type: 'category',
		  axisLabel: { interval: 0, rotate: 40 },
          data: ['Brazil', 'Indonesia', 'USA', 'India', 'China', 'World'],
        },
        series: [
          {
            name: '固定资产',
            type: 'bar',
            barWidth: 15,
            data: [18203, 23489, 29034, 104970, 131744, 630230],
          },
          {
            name: '流动资产',
            type: 'bar',
            barWidth: 15,
            data: [19325, 23438, 31000, 121594, 134141, 681807],
          },
        ],
      }
      option && myChartNowMonth.setOption(option)
    },
  },
}
</script>

<style scoped lang='less'>
.chart_box {
  width: 100%;
  height: 400px;
  float: left;
  position: relative;
  padding: 10px;
  box-sizing: border-box;
  box-shadow: 0 0 5px 1px #e2e2e2;
  border-radius: 5px;
  .chart {
    width: 100%;
    height: 100%;
    float: left;
  }
  .serch_box {
    position: absolute;
    right: 0;
    top: 10px;
    z-index: 999;
  }
}
.chart_main {
  width: 100%;
  height: 750px;
  float: left;
  margin-top: 15px;
  .main_l {
    width: calc(62% - 10px);
	margin-right: 10px;
    height: 100%;
    float: left;
    .main_box {
      width: 100%;
      height: calc(50% - 5px);
      float: left;
      padding: 10px;
      box-sizing: border-box;
      box-shadow: 0 0 5px 1px #e2e2e2;
      border-radius: 5px;
	  &:last-child{
		  margin-top: 10px;
	  }
      .chart_center {
        width: 100%;
        height: 100%;
        float: left;
      }
    }
  }
  .main_r {
    width: 38%;
    height: 100%;
    float: left;
    padding: 10px;
    box-sizing: border-box;
    box-shadow: 0 0 5px 1px #e2e2e2;
    border-radius: 5px;
    .chart_center {
      width: 100%;
      height: 100%;
      float: left;
    }
  }
}
</style>
